/* Mathilde ma muse — accueil (section mmm-home). Généré par preparer.py : ne pas modifier ici. */
(function(){
var racine=document.querySelector('.mmm-home');if(!racine)return;var MMM_BASE=racine.dataset.base||'';
document.documentElement.classList.add('idn-5','idn-js','gestes');
try{
/* Passe identité — propositions du 30/09/2026 (Claude). Se charge par-dessus la maquette de Codex, sans la modifier.
   Chaque proposition s'allume ou se coupe depuis le panneau « Propositions » (aperçu seulement) ou par l'adresse :
   ?p=balance,fil  ·  ?p=aucune  ·  ?p=toutes */
(function () {
  var PROPS = [
    ['balance', 'Le talisman se compose', 'Trois pierres sur un fil, dans « D’abord vos pierres »'],
    ['intentions', 'Chaque intention a sa pierre', 'Une breloque sous chaque photo d’intention'],
    ['fil', 'Le fil de l’atelier', 'Quatre temps sur un fil d’or, la photo suit l’étape'],
    ['point', 'Le point d’or', 'Le point du logo devant les surtitres, au survol des boutons'],
    ['hero', 'Mise au point', 'La photo d’ouverture fait la netteté, le titre monte'],
    ['reveal', 'Révélations sobres', 'Les blocs apparaissent une fois, en douceur']
  ];
  var CLE = 'mmm-passe-identite', toutes = PROPS.map(function (p) { return p[0]; });
  function lire() {
    var q = new URLSearchParams(location.search).get('p');
    if (q) return q === 'aucune' ? [] : q === 'toutes' ? toutes : q.split(',');
    try { var s = localStorage.getItem(CLE); if (s !== null) return s ? s.split(',') : []; } catch (e) {}
    return toutes;
  }
  var actives = ['fil', 'point', 'hero'];
  var html = document.documentElement;
  actives.forEach(function (k) { html.classList.add('id-' + k); });
  var on = function (k) { return actives.indexOf(k) > -1; };
  var calme = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var BASE = 'identite/pierres/';

  /* ——— Moteur de balancier : un ressort amorti par pendentif, réveillé par le défilement, le survol et l'arrivée à l'écran ——— */
  var pendules = [], tourne = false, dernierT = 0, dernierY = 0;
  function pendentif(src, opts) {
    var el = document.createElement('span'); el.className = 'id-pend id-tombe' + (opts.sansBeliere ? ' sans-beliere' : '');
    if (opts.fil) el.style.setProperty('--fil', opts.fil + 'px');
    el.innerHTML = '<i></i><img alt="" src="' + BASE + src + '.png">';
    var p = { el: el, a: 0, v: 0, signe: opts.signe || 1, gain: opts.gain || 1, vu: false, visible: false, depart: opts.depart || 8, delai: opts.delai || 0 };
    pendules.push(p);
    el.addEventListener('pointerenter', function () { pousser(p, 38); });
    return p;
  }
  function pousser(p, v) { if (calme) return; p.v += v * p.signe; if (p.v > 60) p.v = 60; if (p.v < -60) p.v = -60; reveiller(); }
  function reveiller() { if (!tourne) { tourne = true; dernierT = performance.now(); requestAnimationFrame(boucle); } }
  function boucle(t) {
    var dt = Math.min(0.033, (t - dernierT) / 1000); dernierT = t; var encore = false;
    pendules.forEach(function (p) {
      if (!p.vu) return;
      p.v += (-38 * p.a - 2.4 * p.v) * dt; p.a += p.v * dt;
      if (Math.abs(p.a) > 0.04 || Math.abs(p.v) > 0.04) encore = true; else { p.a = 0; p.v = 0; }
      p.el.style.transform = 'rotate(' + p.a.toFixed(2) + 'deg)';
    });
    if (encore) requestAnimationFrame(boucle); else tourne = false;
  }
  function observerPendules() {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var p = pendules.filter(function (x) { return x.el === e.target; })[0]; if (!p) return;
        p.visible = e.isIntersecting;
        if (e.isIntersecting && !p.vu) setTimeout(function () { p.vu = true; p.el.classList.add('vu'); if (!calme) { p.a = p.depart * p.signe; reveiller(); } }, p.delai);
      });
    }, { threshold: 0.6 });
    pendules.forEach(function (p) { io.observe(p.el); });
    if (calme) return;
    dernierY = scrollY;
    addEventListener('scroll', function () {
      var dy = scrollY - dernierY; dernierY = scrollY; if (!dy) return;
      var imp = Math.max(-40, Math.min(40, dy)) * 0.55;
      pendules.forEach(function (p) { if (p.visible && p.vu) pousser(p, imp * p.gain); });
    }, { passive: true });
  }

  /* ——— 1. Le talisman se compose ——— */
  function balance() {
    var copie = document.querySelector('#vos-pierres .quiz-copy'), etapes = copie && copie.querySelector('.steps'); if (!etapes) return;
    var rail = document.createElement('div'); rail.className = 'id-rail';
    [['amazonite', 'Amazonite', 'sérénité', 20, 1, 0], ['pierre-de-lune', 'Pierre de lune', 'se retrouver', 34, -1, 1], ['amethyste', 'Améthyste', 'clarté', 24, 1, 0], ['labradorite', 'Labradorite', 'protection', 28, -1, 0], ['cornaline', 'Cornaline', 'joie', 20, 1, 0], ['quartz-rose', 'Quartz rose', 'douceur', 34, -1, 0]].forEach(function (d, i) {
      var f = document.createElement('figure');
      var p = pendentif(d[0], { fil: d[3], signe: d[4], sansBeliere: d[5], depart: 10, delai: 500 + i * 280, gain: 0.8 + i * 0.2 });
      f.appendChild(p.el);
      var c = document.createElement('figcaption'); c.innerHTML = '<b>' + d[1] + '</b><span>' + d[2] + '</span>'; f.appendChild(c);
      rail.appendChild(f);
    });
    copie.insertBefore(rail, etapes);
    var suite = document.createElement('p'); suite.className = 'id-rail-suite'; suite.textContent = 'Amazonite, pierre de lune et améthyste composent le collier Onde douce.';
    copie.insertBefore(suite, etapes);
    new IntersectionObserver(function (es, o) { es.forEach(function (e) { if (e.isIntersecting) { rail.classList.add('vu'); o.disconnect(); } }); }, { threshold: 0.5 }).observe(rail);
  }

  /* ——— 2. Chaque intention a sa pierre (correspondances tirées des fiches de Mathilde, étude du 27/09) ——— */
  function intentions() {
    var carte = { serenite: ['amazonite', 'Amazonite'], protection: ['labradorite', 'Labradorite'], joie: ['cornaline', 'Cornaline'], douceur: ['quartz-rose', 'Quartz rose'], clarte: ['amethyste', 'Améthyste'], 'se-retrouver': ['pierre-de-lune', 'Pierre de lune', 1] };
    document.querySelectorAll('#intentions a.intention').forEach(function (a, i) {
      var m = (a.getAttribute('href') || '').match(/intention-([a-z-]+)\.html/), d = m && carte[m[1]], titre = a.querySelector('h3'); if (!d || !titre) return;
      var boite = document.createElement('span'); boite.className = 'id-charme'; boite.setAttribute('aria-hidden', 'true');
      var p = pendentif(d[0], { signe: i % 2 ? -1 : 1, sansBeliere: d[2], depart: 9, delai: 150 + (i % 3) * 140, gain: 0.8 + (i % 3) * 0.25 });
      boite.appendChild(p.el); a.insertBefore(boite, titre);
      var nom = document.createElement('span'); nom.className = 'id-pierre-nom'; nom.textContent = d[1]; a.insertBefore(nom, titre);
      a.addEventListener('pointerenter', function () { pousser(p, 30); });
    });
  }

  /* ——— 3. Le fil de l'atelier ——— */
  function fil() {
    var liste = document.querySelector('#atelier .craft-steps'), fig = document.querySelector('#atelier .craft-layout .photo'); if (!liste || !fig) return;
    var items = [].slice.call(liste.children), imgs = [fig.querySelector('img')];
    [2, 3, 4].forEach(function (n) { var im = new Image(); im.src = MMM_BASE + 'mmm-hm-atelier-' + n + '.webp'; im.alt = ''; im.loading = 'lazy'; fig.appendChild(im); imgs.push(im); });
    function mesurer() { liste.style.setProperty('--fil-h', items[items.length - 1].offsetTop + 'px'); }
    var courant = -1, atteint = -1;
    function aller(i) {
      courant = i; if (i > atteint) atteint = i;
      items.forEach(function (li, k) { li.classList.toggle('actif', k === i); li.classList.toggle('fait', k <= atteint && k !== i); });
      imgs.forEach(function (im, k) { im.classList.toggle('actif', k === Math.max(0, i)); });
      liste.style.setProperty('--p', Math.max(0, atteint) / (items.length - 1));
    }
    mesurer(); imgs[0].classList.add('actif'); addEventListener('resize', mesurer);
    /* À l'arrivée à l'écran, les quatre temps s'enchaînent une fois ; ensuite chaque étape répond au survol, au toucher et au clavier. */
    items.forEach(function (li, i) { li.tabIndex = 0; ['pointerenter', 'focus', 'click'].forEach(function (ev) { li.addEventListener(ev, function () { clearInterval(minuteur); aller(i); }); }); });
    var minuteur = 0;
    new IntersectionObserver(function (es, o) {
      if (!es[0].isIntersecting) return; o.disconnect();
      if (calme) { atteint = items.length - 1; aller(0); return; }
      aller(0); minuteur = setInterval(function () { if (courant >= items.length - 1) { clearInterval(minuteur); return; } aller(courant + 1); }, 1300);
    }, { threshold: 0.7 }).observe(liste);
  }

  /* ——— 6. Révélations sobres ——— */
  function reveler() {
    var blocs = document.querySelectorAll('main section:not(#hero) .section-head, main .intention, main .category-card, main article.product, main article.review-tile, main .creator-copy, main .quiz-copy, main .craft-steps li, main .collection-story > div, main .stonebar > div, main details.faq-item, main .services > div, main .reassurance > *');
    var rideaux = document.querySelectorAll('main section:not(#hero) figure.photo');
    blocs.forEach(function (b) { b.setAttribute('data-rev', ''); var i = [].indexOf.call(b.parentNode.children, b); b.style.setProperty('--d', Math.min(i, 5) * 70 + 'ms'); });
    rideaux.forEach(function (r) { r.setAttribute('data-rideau', ''); });
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('vu'); io.unobserve(e.target); } }); }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    [].forEach.call(blocs, function (b) { io.observe(b); }); [].forEach.call(rideaux, function (r) { io.observe(r); });
  }

  /* ——— Panneau de comparaison ——— */
  function panneau() {
    var box = document.createElement('div'); box.className = 'id-panneau';
    var h = '<form><p>Aperçu seulement : ce panneau ne fait pas partie du site.</p>';
    PROPS.forEach(function (p) { h += '<label><input type="checkbox" value="' + p[0] + '"' + (on(p[0]) ? ' checked' : '') + '><span>' + p[1] + '<small>' + p[2] + '</small></span></label>'; });
    h += '<div class="id-actions"><button type="button" data-tout="1">Tout</button><button type="button" data-tout="0">Rien (maquette d’origine)</button></div></form><button type="button" aria-expanded="false">Propositions (' + actives.length + '/' + PROPS.length + ')</button>';
    box.innerHTML = h; document.body.appendChild(box);
    var bouton = box.lastChild, form = box.querySelector('form');
    bouton.addEventListener('click', function () { var o = box.classList.toggle('ouvert'); bouton.setAttribute('aria-expanded', String(o)); });
    function appliquer(liste) { try { localStorage.setItem(CLE, liste.join(',')); } catch (e) {} var u = new URL(location.href); u.searchParams.delete('p'); location.href = u.pathname + u.search + u.hash; if (!u.search && !u.hash) location.reload(); }
    form.addEventListener('change', function () { appliquer([].slice.call(form.querySelectorAll('input:checked')).map(function (i) { return i.value; })); });
    form.querySelectorAll('[data-tout]').forEach(function (b) { b.addEventListener('click', function () { appliquer(b.dataset.tout === '1' ? toutes : []); }); });
  }

  function demarrer() {
    if (on('balance')) balance();
    if (on('intentions')) intentions();
    if (on('fil')) fil();
    if (on('reveal') && !calme) reveler();
    if (pendules.length) observerPendules();
    // Panneau exploratoire retiré de la finale.
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
})();

}catch(e){console.error('mmm-home · identité',e)}
try{
document.querySelectorAll('.review-more').forEach(button=>{const text=document.getElementById(button.getAttribute('aria-controls'));function check(){if(!text.classList.contains('expanded'))button.hidden=text.scrollHeight<=text.clientHeight+1}button.addEventListener('click',()=>{const open=text.classList.toggle('expanded');button.setAttribute('aria-expanded',String(open));button.textContent=open?'Réduire':'Lire la suite'});check();window.addEventListener('load',check);window.addEventListener('resize',check)});

}catch(e){console.error('mmm-home · avis',e)}
try{
document.querySelectorAll('#intentions .intentions-grid,.pierres-grille').forEach(function(z){new IntersectionObserver(function(es,o){if(es.some(function(e){return e.isIntersecting})){z.classList.add('ronds-vus');o.disconnect()}},{threshold:.4}).observe(z)})
}catch(e){console.error('mmm-home · ronds',e)}
try{
(function(){
  function aLEntree(elements, fn, seuil) {
    if (!('IntersectionObserver' in window)) { elements.forEach(fn); return; }
    var io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); fn(e.target); } });
    }, { threshold: seuil || 0.35 });
    elements.forEach(function (el) { io.observe(el); });
  }

  /* 5. Vos pierres, nommées — trois traits désignent les pierres du talisman en photo */
  var cadrePierres = document.querySelector('.discovery-photo'), photoPierres = cadrePierres && cadrePierres.querySelector('img');
  if (photoPierres && /pierres\.webp/.test(photoPierres.getAttribute('src'))) {
    // Coordonnées relevées sur assets/pierres.webp (collier Onde douce : amazonite, pierre de lune, améthyste), en % de l'image.
    var annot = document.createElement('div');
    annot.className = 'annot'; annot.setAttribute('aria-hidden', 'true');
    annot.innerHTML =
      '<i class="perle" style="left:39.9%;top:45.4%;--d:.1s"></i><i class="trait-h" style="left:33%;width:6.9%;top:45.4%;--d:.2s"></i><span class="a-gauche" style="right:68.5%;top:45.4%;--d:.45s">Pierre de lune</span>' +
      '<i class="perle" style="left:36.2%;top:63.6%;--d:.55s"></i><i class="trait-h" style="left:31%;width:5.2%;top:63.6%;--d:.65s"></i><span class="a-gauche" style="right:70.5%;top:63.6%;--d:.9s">Améthyste</span>' +
      '<i class="perle" style="left:52.2%;top:67.9%;--d:1s"></i><i class="trait-v" style="left:52.2%;top:67.9%;height:3.4%;--d:1.1s"></i><span class="a-bas" style="left:52.2%;top:72.2%;--d:1.35s">Amazonite</span>';
    cadrePierres.appendChild(annot);
    var caler = function () {
      annot.style.left = photoPierres.offsetLeft + 'px'; annot.style.top = photoPierres.offsetTop + 'px';
      annot.style.width = photoPierres.offsetWidth + 'px'; annot.style.height = photoPierres.offsetHeight + 'px';
    };
    caler(); addEventListener('resize', caler); addEventListener('load', caler);
    aLEntree([cadrePierres], function () { caler(); annot.classList.add('vu'); }, 0.55);
  }


})();

}catch(e){console.error('mmm-home · annotations',e)}
try{
/* Home Mathilde — « les gestes de l'atelier ». Sans ce script : les six intentions restent des liens vers leur page,
   le panneau Protection est affiché, les étiquettes ne s'affichent pas. */
(function () {
  var actif = document.documentElement.classList.contains('gestes');
  document.querySelectorAll('.maquette-bascule a').forEach(function (a) { a.classList.toggle('actif', (a.dataset.g === '1') === actif); });
  if (!actif) return;

  // 2. Le choix sur place : une intention choisie referme son anneau et montre sa pierre et quatre bijoux.
  var liens = [].slice.call(document.querySelectorAll('.intention[data-intention]'));
  var panneaux = [].slice.call(document.querySelectorAll('.choix-panneau'));
  function choisir(slug, parGeste) {
    liens.forEach(function (l) { var oui = l.dataset.intention === slug; l.classList.toggle('est-choisie', oui); l.setAttribute('aria-pressed', oui); });
    panneaux.forEach(function (p) {
      var oui = p.dataset.intention === slug; p.hidden = !oui; p.classList.remove('entre');
      if (oui && parGeste) { void p.offsetWidth; p.classList.add('entre'); }
    });
    if (parGeste) {
      var zone = document.getElementById('choix').getBoundingClientRect();
      if (zone.top > innerHeight * .78) scrollBy({ top: zone.top - innerHeight * .45, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  }
  liens.forEach(function (l) {
    l.setAttribute('role', 'button');
    l.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;           // nouvel onglet : la page d'intention reste accessible
      e.preventDefault(); choisir(l.dataset.intention, true);
    });
  });
  var depart = panneaux.filter(function (p) { return !p.hidden; })[0];
  if (depart) choisir(depart.dataset.intention, false);
  // Arrivée depuis le menu (« /?intention=joie#intentions ») : l'intention demandée est déjà choisie.
  var voulue = new URLSearchParams(location.search).get('intention');
  if (voulue && liens.some(function (l) { return l.dataset.intention === voulue; })) choisir(voulue, false);

  // 3. L'étiquette de vitrine : reporte un point de la photo d'origine dans son cadre (object-fit: cover).
  function placer() {
    document.querySelectorAll('.etiquette').forEach(function (e) {
      var fig = e.parentElement, img = fig.querySelector('img');
      if (!img || !img.naturalWidth) return;
      var W = fig.clientWidth, H = fig.clientHeight, r = Math.max(W / img.naturalWidth, H / img.naturalHeight);
      var pos = getComputedStyle(img).objectPosition.split(' ').map(parseFloat);
      var dx = (W - img.naturalWidth * r) * (pos[0] || 50) / 100, dy = (H - img.naturalHeight * r) * ((pos[1] === undefined ? 50 : pos[1])) / 100;
      var x = dx + e.dataset.x * img.naturalWidth * r, y = dy + e.dataset.y * img.naturalHeight * r;
      e.style.left = x + 'px'; e.style.top = y + 'px';
      var f = fig.getBoundingClientRect(), b = e.getBoundingClientRect();   // une étiquette rognée par le cadre ne s'affiche pas
      e.classList.toggle('placee', x > 12 && x < W - 12 && y > 16 && y < H - 16 && b.left >= f.left + 4 && b.right <= f.right - 4 && b.bottom <= f.bottom - 4);
    });
  }
  document.querySelectorAll('figure:has(>.etiquette) img').forEach(function (i) { i.addEventListener('load', placer); });
  addEventListener('resize', placer); addEventListener('load', placer); placer();
})();

}catch(e){console.error('mmm-home · gestes',e)}
})();
